'use strict';
var React = require('react-native');
var {StyleSheet, Dimensions} = React;

// ── Type scale ──────────────────────────────────────────────────────────────
// Single source of truth. All shared stylesheets pull from these tokens.
// Use the semantic names (display, pageTitle, …) in new code.
// Legacy names (h1, h2, …) are kept as aliases so existing imports don't break.

export const display = {
  fontSize: 30,
  fontWeight: '700',
};

export const pageTitle = {
  fontSize: 24,
  fontWeight: '600',
};

export const sectionTitle = {
  fontSize: 18,
  fontWeight: '600',
};

export const body = {
  fontSize: 16,
  fontWeight: '400',
};

export const bodyStrong = {
  fontSize: 16,
  fontWeight: '600',
};

export const label = {
  fontSize: 14,
  fontWeight: '500',
};

export const caption = {
  fontSize: 12,
  fontWeight: '500',
};

export const micro = {
  fontSize: 11,
  fontWeight: '500',
};

// ── Legacy aliases ───────────────────────────────────────────────────────────
export const h1 = display;
export const h2 = pageTitle;
export const h3 = body;
export const h4 = label;
export const p1 = body;
export const p2 = label;
export const t1 = body;
export const t2 = label;
export const b1 = caption;
export const b2 = caption;
export const button1 = label;
export const button2 = label;
